import React from "react";
import { Link } from 'react-router-dom';
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaChevronRight,
  FaShieldAlt,
  FaCertificate
} from "react-icons/fa";
import Logo from "../image/Logo_Nav.webp";
import FooterBg from "../image/FooterBackground.webp";
import "../App.css";

export default function Footer() {
  return (
    <footer className="footer-section position-relative overflow-hidden" style={{
      backgroundImage: `linear-gradient(180deg, rgba(10, 22, 40, 0.94) 0%, rgba(4, 10, 20, 0.98) 100%), url(${FooterBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}>
      <div className="container py-5 position-relative z-1">
        <div className="row g-4 g-lg-5">
          {/* Column 1: Brand & Bio */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-logo-box mb-3">
              <img src={Logo} alt="Shree Kamdhenu Furniture" className="footer-logo-img" />
            </div>
            <p className="footer-desc mb-3">
              Providing Premium Steel & Box Beds, Laser Art Cupboards, and Storage Solutions — Built on Quality, Trust, and Reliability.
            </p>

            {/* Clean Trust Line */}
            <div className="footer-trust-text mb-4">
              <span className="d-inline-flex align-items-center gap-1 me-3"><FaCertificate className="text-primary" /> ISO 9001:2015 Certified</span>
              <span className="d-inline-flex align-items-center gap-1"><FaShieldAlt className="text-primary" /> GeM Registered</span>
            </div>

            {/* Social Links */}
            <div className="d-flex align-items-center gap-2">
              <a href="https://www.facebook.com/kamdhenu.steelindustries.2025" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Facebook"><FaFacebookF /></a>
              <a href="https://www.instagram.com/kamdhenusteelindustries1995/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Instagram"><FaInstagram /></a>
              <a href="https://www.youtube.com/@KAMDHENUSTEELINDUSTRIES" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="YouTube"><FaYoutube /></a>
              <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Chat on WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-links-list">
              <li><Link to="/" className="footer-link-item"><FaChevronRight className="link-arrow" /> Home</Link></li>
              <li><Link to="/collections" className="footer-link-item"><FaChevronRight className="link-arrow" /> Our Products</Link></li>
              <li><Link to="/about" className="footer-link-item"><FaChevronRight className="link-arrow" /> About Us</Link></li>
              <li><Link to="/clients" className="footer-link-item"><FaChevronRight className="link-arrow" /> Our Clients</Link></li>
              <li><Link to="/infrastructure" className="footer-link-item"><FaChevronRight className="link-arrow" /> Project Gallery</Link></li>
              <li><Link to="/contact" className="footer-link-item"><FaChevronRight className="link-arrow" /> Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div className="col-lg-5 col-md-12">
            <h5 className="footer-heading">Contact Information</h5>

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <FaMapMarkerAlt />
              </div>
              <div>
                <div className="footer-contact-label">Factory Address</div>
                <div className="footer-contact-text">
                  <a href="https://share.google/wGLZ3vJLBz6zjMhCd" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
                    Block No.221, New Ring Road, Saniya Kosmada Chokdi, Kosmada - 395006, Surat, Gujarat.
                  </a>
                </div>
              </div>
            </div>

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <FaEnvelope />
              </div>
              <div>
                <div className="footer-contact-label">Email Support</div>
                <div className="footer-contact-text">
                  <a href="mailto:kamdhenusteelindustries99@gmail.com" className="footer-contact-link">kamdhenusteelindustries99@gmail.com</a>
                </div>
              </div>
            </div>

            <div className="footer-contact-item mb-0">
              <div className="footer-contact-icon">
                <FaPhoneAlt />
              </div>
              <div>
                <div className="footer-contact-label">Call & WhatsApp</div>
                <div className="footer-contact-text d-flex flex-column gap-1">
                  <div>
                    <a href="tel:+917202057575" className="footer-contact-link fw-semibold">+91 72020 57575</a> <span className="opacity-75" style={{ fontSize: '0.8rem' }}>(Customer Care)</span>
                  </div>
                  <div>
                    <a href="tel:+919624882499" className="footer-contact-link fw-semibold">+91 96248 82499</a> <span className="opacity-75" style={{ fontSize: '0.8rem' }}>(Vikram Sakariya)</span>
                  </div>
                  <div>
                    <a href="tel:+919924382499" className="footer-contact-link fw-semibold">+91 99243 82499</a> <span className="opacity-75" style={{ fontSize: '0.8rem' }}>(Rakshit Sakariya)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="footer-bottom-bar py-3">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 text-center text-md-start">
          <div className="footer-copyright">
            © {new Date().getFullYear()} <span className="text-light fw-semibold">Shree Kamdhenu Furniture</span>. All rights reserved.
          </div>
          <div className="footer-powered">
            Powered by <a href="https://liontouchwebpark.com/" target="_blank" rel="noopener noreferrer">Liontouch Webpark.</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
